import React from 'react';
import { useIntl } from 'react-intl';
import { ProposalAIPrimaryButton } from './ProposalAIPrimaryButton';
import { HeadingSegmentAIPanel } from './HeadingSegmentAIPanel';
import { useHeadingSegmentAI } from '../hooks';

interface Props {
  index: number;
}

export const HeadingSegmentAI: React.FC<Props> = ({ index }) => {
  const { formatMessage } = useIntl();
  const headingAI = useHeadingSegmentAI(index);

  if (!headingAI.shouldRender) {
    return null;
  }

  return (
    <div className="proposal-heading-ai">
      {!headingAI.isOpen ? (
        <ProposalAIPrimaryButton
          label={formatMessage({ id: 'proposal-ai.heading.open' })}
          onClick={headingAI.handleOpen}
          btnSelector="proposal-ai-heading-open"
          style="outline"
          size="med"
          className="proposal-heading-ai__trigger"
        />
      ) : (
        <HeadingSegmentAIPanel
          index={index}
          prompt={headingAI.prompt}
          generated={headingAI.generated}
          isGenerating={headingAI.isGenerating}
          isGeneratedStale={headingAI.isGeneratedStale}
          onPromptChange={headingAI.setPrompt}
          onGenerate={headingAI.handleGenerate}
          onApply={headingAI.handleApply}
          onCancel={headingAI.resetState}
        />
      )}
    </div>
  );
};
